export const constants = { token: 'fasterToken', userInfo: 'fasterInfo', tokenV2: 'fasterTokenV2' };